module.exports = __webpack_public_path__ + "img/banner2.c9fcce29.c9fcce29.jpg";